import React, { Component } from 'react';
import UserProfile          from './components/UserProfile';
//import RedirectHocks from './components/RedirectHocks';
import { Route }            from 'react-router';
import { Layout }           from './components/Layout';
import { Home }             from './components/Home';
import { Users }            from './components/Users';
import { Registry }         from './components/Registry';
import { Transfer }         from './components/Transfer';
import { Transaction }      from './components/Transaction';
import { TransactionOut }   from './components/TransactionOut';
import { Login }            from './components/Login';
import { QRCodes }          from './components/QRCodes';
import { ECards }           from './components/ECards';
import { EuronetCredits } from './components/EuronetCredits';
import { Statistics } from './components/Statistics';
import { useHistory } from 'react-router-dom';

export default class App extends Component {
    displayName = App.name

    constructor(props) {
        super(props);
        UserProfile.init();
        this.forceRender();
        setInterval(() => {
            let promiseRefresh = new Promise((resolve, reject) => {

                resolve(UserProfile.refreshSession());
            });
            promiseRefresh.then(function (value) {
                var url = document.location.href.replace(/^.*\/\/[^\/]+/, '');
                if (value == false && url != '/login') {
                    document.location.href = '/login';
                    console.log('go to login - 1');
                    this.forceRender();
                } else {
                }
            });
            var url = document.location.href.replace(/^.*\/\/[^\/]+/, '');
            if (UserProfile.IsAuth() == 'false' && url != '/login') {
                UserProfile.saveLogout();
                console.log('go to login - 2');
                document.location.href = '/login';
            }
            this.forceRender();
        }, 60000);
    }
    forceRender = event => {
        this.setState({ time: Date.now() })
    }

    render() {
    return (
      <Layout>
            <Route exact path='/' component={Home} />
            <Route path='/users' component={Users} />
            <Route path='/Statistics' component={Statistics} />
            <Route path='/registry' component={Registry} />
            <Route path='/transfer' component={Transfer} />
            <Route path='/transaction' component={Transaction} />
            <Route path='/transactionOut' component={TransactionOut} />
            <Route path='/login' component={Login} user={UserProfile.getLogin()}/>
            <Route path='/qrcodes' component={QRCodes} />
            <Route path='/ecards' component={ECards} />
            <Route path='/euronetCredits' component={EuronetCredits} />
      </Layout>
    );
  }
}
